import shapeData from './shapeData.json';
import roundGroupData from './roundGroupData.json';
import cellPointsData from './cellPointsData.json';

import { Block } from '../models/block';
import { GridPosition } from '../models/grid-position';
import { RoundGroup } from '../models/round-group';
import { Shape } from '../models/shape';
import { CellPoints } from '../grid/cell-points';

interface IPosition {
  row: number;
  col: number;
}

interface IBlock {
  ID: string;
  PosInShape: IPosition;
  Multiplier: number;
}

interface IShape {
  CanBePlaced: boolean;
  ID: string;
  ShapeNum: number;
  Blocks: IBlock[];
}

export class DataImporter {
  public static importShapes() {
    const shapes = shapeData as IShape[];
    return shapes.map((shape) => {
      const blocks = shape.Blocks.map(
        (block) => new Block(new GridPosition(block.PosInShape.row, block.PosInShape.col)),
      );
      return new Shape(blocks, shape.ShapeNum);
    });
  }

  public static importRoundGroups() {
    return roundGroupData as RoundGroup[];
  }

  public static importCellPoints() {
    return cellPointsData as CellPoints[];
  }
}
